import React, { useState } from "react";
import { loginByEmail } from "../../utils/api";
import InputField from "./InputField";
import UIButton from "../../../../globalComponents/UIComponents/UIButton";
import { PasswordLock } from "./EmailPasswordRequest";

export default ({ eventKey, passwordUpdateLock, setPasswordUpdateLock, email, $locale, hideInfoBlock, onSuccess, handleSendSMS }) => {
    const Heading = hideInfoBlock ? 'h1' : 'h2';

    const [code, setCode] = useState('');
    const [error, setError] = useState({});
    const [disabled, setDisabled] = useState(false);
    const [isPasswordVisible, setPasswordVisible] = useState(false);

    const handleSetError = (value) => {
        if (value) return;

        setError({ code: { hasError: true, name: '' } });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (disabled) {
            return;
        }

        setDisabled(true);

        try {
            if (onSuccess) {
                const client = await loginByEmail(eventKey, { email, code });
                await onSuccess(client);
            }
        } catch (e) {
            setError({
                code: {
                    hasError: true,
                    name: code.length ? $locale.get('auth.login.email.wrongCode') : '',
                },
            });
            setDisabled(false);
        }
    }

    return (
        <>
            <Heading>{$locale.get('auth.login.email.success.title')}</Heading>
            <span>{$locale.get('auth.login.phone.success.password')}</span>
            <form
                onSubmit={handleSubmit}
                className="email-request-form auth-container"
                noValidate
            >
                <div>
                    <InputField
                        value={code}
                        label={$locale.get('auth.login.email.onetimeCode')}
                        type={isPasswordVisible ? 'text' : 'password'}
                        name="password"
                        autoComplete="off"
                        required
                        placeholder={$locale.get('auth.login.phone.success.password.placeholder')}
                        disabled={disabled}
                        error={error?.code?.hasError}
                        errorName={error?.code?.name}
                        isPasswordType={true}
                        isPasswordVisible={isPasswordVisible}
                        onChange={(value) => {
                            setCode(value);
                            setError({});
                        }}
                        onBlur={(e) => handleSetError(e.target.value)}
                        onClickInputButton={() => setPasswordVisible(!isPasswordVisible)}
                    />
                    <UIButton
                        type="button"
                        disabled={disabled || passwordUpdateLock}
                        onClick={handleSendSMS}
                        color="transparent"
                        style={`link ${!passwordUpdateLock ? 'accent' : ''}`}
                    >
                        {$locale.get('auth.login.button.sendCodeAgain')}
                        {passwordUpdateLock && (
                            <>
                                &nbsp;{$locale.get('auth.login.button.sendCodeAgainVia')}
                                <PasswordLock passwordLockTime={passwordUpdateLock} onStop={() => setPasswordUpdateLock(null)} />
                            </>
                        )}
                    </UIButton>
                </div>
                <UIButton
                    type="submit"
                    size="large"
                    color={code && !error.code ? 'primary' : 'not-active'}
                    disabled={disabled}
                >
                    {$locale.get('auth.login.submit')}
                </UIButton>
            </form>
        </>
    );
} 